// Bridges the Prestige product form (sections/prestige-main-product.liquid) with Horizon's cart drawer & cart icon.
import { CartLinesUpdateEvent } from '@shopify/events';

// Ask Shopify to render Horizon's cart sections in the /cart/add.js response, so the drawer can morph without a refetch
document.addEventListener('cart:prepare-bundled-sections', (event) => {
  document.querySelectorAll('cart-items-component').forEach((element) => {
    if (element instanceof HTMLElement && element.dataset.sectionId) {
      event.detail.sections.push(element.dataset.sectionId);
    }
  });
});

document.addEventListener('cart:change', (event) => {
  const { baseEvent, cart } = event.detail || {};
  if (baseEvent !== 'variant:add' || !cart) return;

  const deferred = CartLinesUpdateEvent.createPromise();
  const source = document.querySelector('.prestige-scope') || document.body;

  source.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: cart.items.map((item) => ({ merchandiseId: String(item.variant_id), quantity: item.quantity })),
      promise: deferred.promise,
    })
  );

  deferred.resolve({
    cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
    detail: {
      items: cart.items,
      source: 'prestige-product-form',
      itemCount: cart.item_count,
      sections: cart.sections,
      didError: false,
    },
  });
});

// Prestige computes carousel scroll positions from `document.dir`, which Swishin's <html> doesn't set.
// Without it every thumbnail click resolves to scrollLeft 0, so the main image never changes.
if (!document.documentElement.getAttribute('dir')) {
  document.documentElement.setAttribute('dir', 'ltr');
}

// Zoom lightbox (PhotoSwipe) is appended to <body>, outside .prestige-scope, so it misses the section's colors.
new MutationObserver(() => {
  document.querySelectorAll('.pswp:not(.prestige-scope)').forEach((element) => {
    element.classList.add('prestige-scope');
  });
}).observe(document.body, { childList: true });

// Thin previous/next arrows over the main product image
const ARROW_STYLE = `
  .prestige-scope .pr-gallery-arrow {
    position: absolute; top: 50%; z-index: 2; transform: translateY(-50%);
    display: grid; place-items: center; width: 2.75rem; height: 2.75rem;
    padding: 0; border: 0; background: transparent; color: rgb(var(--text-color)); cursor: pointer;
    opacity: .7; transition: opacity .2s;
  }
  .prestige-scope .pr-gallery-arrow:hover { opacity: 1; }
  .prestige-scope .pr-gallery-arrow[disabled] { opacity: .2; cursor: default; }
  .prestige-scope .pr-gallery-arrow--prev { left: .5rem; }
  .prestige-scope .pr-gallery-arrow--next { right: .5rem; }
  .prestige-scope .pr-gallery-arrow svg { width: 22px; height: 22px; }
`;
const ARROW_ICON = (direction) =>
  `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" aria-hidden="true"><path d="${direction === 'prev' ? 'M15 4 7 12l8 8' : 'm9 4 8 8-8 8'}"/></svg>`;

function addGalleryArrows() {
  document.querySelectorAll('.prestige-scope .product-gallery__image-list').forEach((list) => {
    const carousel = list.querySelector('scroll-carousel');
    if (!carousel || list.querySelector('.pr-gallery-arrow') || carousel.querySelectorAll('.product-gallery__media').length < 2) return;

    list.style.position = 'relative';
    const buttons = ['prev', 'next'].map((direction) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `pr-gallery-arrow pr-gallery-arrow--${direction}`;
      button.setAttribute('aria-label', direction === 'prev' ? 'Previous image' : 'Next image');
      button.innerHTML = ARROW_ICON(direction);
      button.addEventListener('click', () => (direction === 'prev' ? carousel.previous() : carousel.next()));
      list.appendChild(button);
      return button;
    });

    const update = () => {
      const index = carousel.selectedIndex;
      buttons[0].disabled = index <= 0;
      buttons[1].disabled = index >= carousel.cells.length - 1;
    };
    carousel.addEventListener('carousel:change', update);
    carousel.addEventListener('carousel:settle', update);
    customElements.whenDefined('scroll-carousel').then(update);
  });
}

if (!document.getElementById('pr-gallery-arrow-style')) {
  const style = document.createElement('style');
  style.id = 'pr-gallery-arrow-style';
  style.textContent = ARROW_STYLE;
  document.head.appendChild(style);
}
addGalleryArrows();
// The product section re-renders on variant change; re-attach arrows to the new gallery
new MutationObserver(addGalleryArrows).observe(document.querySelector('.prestige-scope') || document.body, { childList: true, subtree: true });

// "X people are viewing this right now" — a random 6–10 per product, drifting by ±1 every few seconds.
// Kept in sessionStorage so the number doesn't jump on reload / variant re-render.
const VIEWERS_MIN = 6;
const VIEWERS_MAX = 10;
const viewersKey = `pr-viewers:${location.pathname}`;
const randomViewers = () => VIEWERS_MIN + Math.floor(Math.random() * (VIEWERS_MAX - VIEWERS_MIN + 1));

let viewers;
try {
  viewers = parseInt(sessionStorage.getItem(viewersKey), 10);
} catch (error) {}
if (!(viewers >= VIEWERS_MIN && viewers <= VIEWERS_MAX)) viewers = randomViewers();

const paintViewers = () => {
  document.querySelectorAll('[data-pr-viewers]').forEach((element) => {
    if (element.textContent !== String(viewers)) element.textContent = viewers;
  });
  try {
    sessionStorage.setItem(viewersKey, viewers);
  } catch (error) {}
};

paintViewers();
setInterval(() => {
  const next = viewers + (Math.random() < 0.5 ? -1 : 1);
  viewers = Math.min(VIEWERS_MAX, Math.max(VIEWERS_MIN, next));
  paintViewers();
}, 7000);
new MutationObserver(paintViewers).observe(document.querySelector('.prestige-scope') || document.body, { childList: true, subtree: true });